"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchWithRetries;
Object.defineProperty(exports, "TimeoutError", {
  enumerable: true,
  get: function get() {
    return _TimeoutError.default;
  }
});
Object.defineProperty(exports, "ResponseError", {
  enumerable: true,
  get: function get() {
    return _ResponseError.default;
  }
});

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _js = require("@adeira/js");

var _fetch = _interopRequireDefault(require("./fetch"));

var _TimeoutError = _interopRequireDefault(require("./TimeoutError"));

var _ResponseError = _interopRequireDefault(require("./ResponseError"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_TIMEOUT = 15000;
var DEFAULT_RETRIES = [1000, 3000];

function isNodejs() {
  var _process$versions;

  // Next.js has global `process` object even in Browser so we have to be more thorough here.
  // Please, leave it written exactly like this: we have to first check if `process` exists
  // manually (a?.b would fail otherwise). Then we cannot assume `versions` exist.
  // $FlowExpectedError[unnecessary-optional-chain]: field `versions` doesn't have to exist (see Browsers env)
  return typeof process !== 'undefined' && ((_process$versions = process.versions) === null || _process$versions === void 0 ? void 0 : _process$versions.node) !== undefined;
}

function getEnvironmentHeaders() {
  return isNodejs() ? {
    // Cross-fetch uses node-fetch behind the scenes (in Node.js envs) which
    // sets default UA header (https://github.com/bitinn/node-fetch/blob/95286f52bb866283bc69521a04efe1de37b26a33/src/request.js#L225).
    // We overwrite it here to make clear where is this request actually
    // coming from. See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent
    'User-Agent': '@adeira/fetch (+https://github.com/adeira/universe)'
  } : null;
}
/**
 * Makes a request to the server with the given data as the payload.
 * Automatic retries are done based on the values in `retryDelays`.
 */


function fetchWithRetries(resource, initWithRetries) {
  var _ref = initWithRetries !== null && initWithRetries !== void 0 ? initWithRetries : {},
      fetchTimeout = _ref.fetchTimeout,
      retryDelays = _ref.retryDelays,
      initHeaders = _ref.headers,
      init = (0, _objectWithoutProperties2.default)(_ref, ["fetchTimeout", "retryDelays", "headers"]);

  var _fetchTimeout = fetchTimeout != null ? fetchTimeout : DEFAULT_TIMEOUT;

  var _retryDelays = retryDelays != null ? retryDelays : DEFAULT_RETRIES;

  var requestsAttempted = 0;
  var requestStartTime = 0;
  return new Promise(function (resolve, reject) {
    /**
     * Sends a request to the server that will timeout after `fetchTimeout`.
     * If the request fails or times out a new request might be scheduled.
     */
    function sendTimedRequest() {
      requestsAttempted++;
      requestStartTime = Date.now();
      var isRequestAlive = true;
      var request = (0, _fetch.default)(resource, _objectSpread(_objectSpread({}, init), {}, {
        headers: _objectSpread(_objectSpread({}, getEnvironmentHeaders()), initHeaders)
      }));
      var requestTimeout = setTimeout(function () {
        isRequestAlive = false;

        if (shouldRetry(requestsAttempted)) {
          retryRequest('HTTP timeout', resource);
        } else {
          reject(new _TimeoutError.default((0, _js.sprintf)("fetchWithRetries: Failed to get response from server (".concat(resource, "), tried %s times."), requestsAttempted)));
        }
      }, _fetchTimeout);
      request.then(function (response) {
        // We got a response, we can clear the timeout.
        clearTimeout(requestTimeout);

        if (isRequestAlive) {
          if (response.status >= 200 && response.status < 300) {
            // Got a response code that indicates success, resolve the promise.
            resolve(response);
          } else if (shouldRetry(requestsAttempted, response.status)) {
            // Fetch was not successful, retrying.
            retryRequest("HTTP error ".concat(response.status), resource);
          } else {
            // Request was not successful, giving up.
            reject(new _ResponseError.default(response, (0, _js.sprintf)('fetchWithRetries: Still no successful response after ' + '%s retries, giving up.', requestsAttempted)));
          }
        }
      }).catch(function (error) {
        clearTimeout(requestTimeout);

        if (shouldRetry(requestsAttempted)) {
          retryRequest(error.message, resource);
        } else {
          reject(error);
        }
      });
    }
    /**
     * Similar to `sendTimedRequest` except it completely ignores timeouts and retries.
     */


    function sendRequest() {
      var request = (0, _fetch.default)(resource, _objectSpread(_objectSpread({}, init), {}, {
        headers: _objectSpread(_objectSpread({}, getEnvironmentHeaders()), initHeaders)
      }));
      request.then(function (response) {
        // We got a response, we can clear the timeout.
        if (response.status >= 200 && response.status < 300) {
          // Got a response code that indicates success, resolve the promise.
          resolve(response);
        } else {
          // Request was not successful, giving up.
          reject(new _ResponseError.default(response, 'fetch: No successful response, giving up.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    }
    /**
     * Schedules another run of sendTimedRequest based on how much time has
     * passed between the time the last request was sent and now.
     */


    function retryRequest(reason, resource) {
      process.env.NODE_ENV !== "production" ? (0, _js.warning)(false, "fetchWithRetries: ".concat(reason, " (").concat(resource, "), retrying.")) : void 0;
      var retryDelay = _retryDelays[requestsAttempted - 1];
      var retryStartTime = requestStartTime + retryDelay; // Schedule retry for a configured duration after last request started.

      setTimeout(sendTimedRequest, retryStartTime - Date.now());
    }
    /**
     * Checks if another attempt should be done to send a request to the server.
     * It returns false for non-transient HTTP status codes like 401 or 403.
     */


    function shouldRetry(attempt, statusCode) {
      var nonTransientCodes = [400, // Bad Request (it's not gonna be better next time)
      401, // Unauthorized (request is not authorized - next time the same)
      403, // Forbidden (server understands but refuses to authorize)
      422, // Unprocessable entity (wrong form body, unlikely to change from retry)
      429 // Too Many Requests (stop DDoS-ing, rate limiting); TODO: take into account `Retry-After` header https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
      // TODO: consider every 4xx code?
      //  https://stackoverflow.com/q/47680711/3135248
      ];

      if (statusCode != null && nonTransientCodes.includes(statusCode)) {
        return false;
      }

      return attempt <= _retryDelays.length;
    }

    if (init.body == null || typeof init.body === 'string') {
      sendTimedRequest();
    } else {
      // We don't want to send "timed" request when the body is defined but it's not a string. For
      // example, it makes sense to retry GraphQL requests with JSON-stringified body, but it's not
      // a good idea to retry when the body is type of `FormData` for example (file upload).
      sendRequest();
    }
  });
}